import { Avatar, Box, Chip, CircularProgress, Stack } from "@mui/material";
import { IconSearch } from "@tabler/icons-react";
import { useState } from "react";
import Text from "../../../../components/ui/Text";
import { PLAYER_ROLES } from "../../../../constants/game";
export const Members = ({
  members,
  pagination,
  loading,
  loadingMore,
  observerRef,
  selectedMembers,
  onMemberSelect,
}) => {
  const [searchMembers, setSearchMembers] = useState("");

  const handleMemberSearch = (event) => {
    setSearchMembers(event.target.value);
  };
  const filteredMembers = members?.filter(
    (member) =>
      member.first_name.toLowerCase().includes(searchMembers.toLowerCase()) ||
      member.last_name.toLowerCase().includes(searchMembers.toLowerCase()) ||
      member.email.toLowerCase().includes(searchMembers.toLowerCase()),
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 4,
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  if (!members || members.length === 0) {
    return (
      <Text component="p" variant="paragraph" sx={{ textAlign: "center" }}>
        No members to invite.
      </Text>
    );
  }

  return (
    <>
      <Stack spacing={3}>
        {/* Search Bar */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            backgroundColor: "white",
            border: "1px solid #A1A1A1",
            borderRadius: "2px",
            px: 2,
            py: 1,
          }}
        >
          <IconSearch size={22} color="#A1A1A1" />
          <Box
            component="input"
            placeholder="Search members"
            value={searchMembers}
            onChange={handleMemberSearch}
            sx={{
              border: "none",
              outline: "none",
              backgroundColor: "transparent",
              fontSize: "16px",
              flex: 1,
              "&::placeholder": {
                color: "#A1A1A1",
              },
            }}
          />
        </Box>

        {/* Members List - Using GameDetails player card format */}
        <Stack spacing={2}>
          {filteredMembers?.map((member) => {
            const isSelected = selectedMembers
              .map((m) => m.id)
              .includes(member.id);
            return (
              <Box
                key={member.id}
                onClick={() => onMemberSelect(member)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  bgcolor: "white",
                  p: 1,
                  borderRadius: "8px",
                  cursor: "pointer",
                  border: isSelected
                    ? "2px solid #1890FF"
                    : "2px solid transparent",
                  transition: "all 0.2s",
                  "&:hover": {
                    bgcolor: "#F5F5F5",
                  },
                }}
              >
                <Avatar
                  src={member?.profile_image_url}
                  sx={{ width: 40, height: 40, fontSize: "16px" }}
                >
                  {member?.first_name?.[0].toUpperCase()}
                  {member?.last_name?.[0].toUpperCase()}
                </Avatar>
                <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
                  <Text
                    variant="paragraph"
                    sx={{ fontSize: "16px", fontWeight: 500 }}
                  >
                    {member.first_name} {member.last_name}
                  </Text>
                  <Text
                    variant="paragraph"
                    sx={{
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#666666",
                      lineHeight: 1,
                    }}
                  >
                    {member.email}
                  </Text>
                </Box>
                {member.role === PLAYER_ROLES.HOST && (
                  <Chip
                    label="Host"
                    size="small"
                    sx={{
                      backgroundColor: "#E6F4FF",
                      color: "#1890FF",
                      fontSize: "12px",
                      px: 1,
                      height: "24px",
                    }}
                  />
                )}
                <Box
                  sx={{
                    width: 18,
                    height: 18,
                    borderRadius: "4px",
                    bgcolor: isSelected ? "#1890FF" : "transparent",
                    border: isSelected
                      ? "1px solid #1890FF"
                      : "1px solid #d9d9d9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  {isSelected && "✓"}
                </Box>
              </Box>
            );
          })}

          {pagination.has_next_page && (
            <Box
              ref={observerRef}
              id="load-more-anchor"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                py: 3,
              }}
            >
              {loadingMore ? (
                <CircularProgress size={32} />
              ) : (
                <Box sx={{ opacity: 0, height: "1px" }}>Anchor</Box>
              )}
            </Box>
          )}
        </Stack>
      </Stack>
    </>
  );
};
